"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _async = _interopRequireDefault(require("react-select/async"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _objectToOption = _interopRequireDefault(require("./objectToOption"));
var _GetOption = _interopRequireDefault(require("./GetOption"));
var _getIndexes = _interopRequireDefault(require("../getIndexes"));
var _excluded = ["className", "field", "fields", "object", "target", "isMulti", "schemas", "find", "where", "disabled", "onChange", "label", "indexes", "portal"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputRelation/index.js";
var defaultProps = {
  where: {},
  schemas: [],
  onChange: function onChange() {},
  portal: document.body
};
function InputRelation(_ref) {
  var className = _ref.className,
    field = _ref.field,
    fields = _ref.fields,
    object = _ref.object,
    target = _ref.target,
    isMulti = _ref.isMulti,
    schemas = _ref.schemas,
    find = _ref.find,
    where = _ref.where,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    label = _ref.label,
    indexes = _ref.indexes,
    portal = _ref.portal,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  // get schema
  var schema = schemas.find(function (s) {
    return s.collection === target;
  });
  var _fields = fields || schema && schema.fields;
  if (_fields === undefined) return null;
  var _indexes = indexes || _react["default"].useMemo(function () {
    var items = (0, _getIndexes["default"])(_fields);
    return items.length > 0 ? items : ['name'];
  }, [_fields]);
  var _React$useState = _react["default"].useState([]),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  // set default value
  _react["default"].useEffect(function () {
    var defaultValue = object[field];
    if (isMulti) {
      defaultValue && setValue(defaultValue.map(function (obj) {
        return (0, _objectToOption["default"])(obj, _indexes);
      }));
      object[field] = [];
    } else {
      defaultValue && setValue((0, _objectToOption["default"])(defaultValue, _indexes));
    }
  }, [object, field, _indexes]);
  function loadOptions(word, callback) {
    new _GetOption["default"](target, _indexes, word, callback, find, where);
  }
  function _onChange(data) {
    if (isMulti) {
      // filter new value
      var added = data.filter(function (i) {
        return !value.includes(i);
      }).map(function (o) {
        return {
          id: o.value
        };
      });
      // filter removed value
      var removed = value.filter(function (i) {
        return !data.includes(i);
      }).map(function (o) {
        return {
          id: o.value,
          __operation: 'REMOVE'
        };
      });
      var objects = [].concat((0, _toConsumableArray2["default"])(added), (0, _toConsumableArray2["default"])(removed));
      object[field] = [].concat((0, _toConsumableArray2["default"])(objects), (0, _toConsumableArray2["default"])(object[field].filter(function (a) {
        return !objects.find(function (b) {
          return a.id === b.id;
        });
      })));
    } else {
      object[field] = {
        id: data.value
      };
    }
    setValue(data);
    onChange(isMulti ? data.map(function (o) {
      return o.object;
    }) : data.object);
  }
  return /*#__PURE__*/_react["default"].createElement(_async["default"], Object.assign({
    placeholder: label || "select ".concat(field),
    classNamePrefix: "custom-form-control",
    menuPortalTarget: portal,
    loadOptions: loadOptions,
    value: value,
    defaultOptions: true,
    onChange: _onChange,
    className: (0, _classNames["default"])(className),
    isMulti: isMulti,
    cacheOptions: true,
    isDisabled: disabled
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 9
    }
  }));
}
InputRelation.defaultProps = defaultProps;
var _default = InputRelation;
exports["default"] = _default;